/* eslint-disable react/jsx-curly-brace-presence */
import React, { Component } from 'react';
import ButtonApp from 'components/ButtonAppNew';

import { Main, SecurityItem, ButtonWrap, AdvancedLink } from './styles';
import Title from './Title';
import Text from './Text';
import TextField from './TextField';
import PasswordInput from './PasswordInput';
import BaseInput from './BaseInput';
import FormItem from './FormItem';
import Select from './Select';
import FormRow from './FormRow';

const region = [
  { value: 'Region 1', label: 'Region' },
  { value: 'Region 2', label: 'Region 2' },
  { value: 'Region 3', label: 'Region 3' },
  { value: 'Region 4', label: 'Region 4' },
];

export class Warehouses extends Component {
  render() {
    return (
      <Main>
        <div>
          <Title>Cluster Settings</Title>
          <Text>To start sending data to your cluster, enter cluster details below.</Text>


          <FormRow>
            <FormItem col={8}>
              <TextField label="Endpoint" />
            </FormItem>

            <FormItem col={4}>
              <TextField label="Port" />
            </FormItem>

            <FormItem col={8}>
              <TextField label="Database name" />
            </FormItem>

            <FormItem col={4}>
              <Select options={region} value="Region 1" />
            </FormItem>

            <FormItem col={6}>
              <TextField label="Username" />
            </FormItem>

            <FormItem col={6}>
              <PasswordInput label="Password" />
            </FormItem>
          </FormRow>
        </div>

        <br /><br /><br />

        <div>
          <Title>Add security settings to allow FlyData to send Data</Title>
          <Text>Please go to your AWS Console and add the following IP adresses to your Redshift security settings</Text>

          <SecurityItem>
            <BaseInput value="54.86.209.233/32" />
          </SecurityItem>

          <SecurityItem>
            <BaseInput value="54.86.209.233/32" />
          </SecurityItem>
        </div>

        <br /><br /><br />

        <div>
          <Title>S3 Bucket</Title>
          <Text>{"By setting your own S3 Bucket, you can backup your data in S3 as much as you'd like. Please add permissions for secure@flydata.co with upload/delete and view permissions with your AWS console"}</Text>

          <SecurityItem>
            <TextField label="S3 Bucket address" helperText="optional" />
          </SecurityItem>

          <Text>
            Enhanced VPN Routing: If you are not using your own S3 bucket, please do not enable Enhanced VPN routing. More info.
          </Text>
        </div>

        <br />

        <AdvancedLink>
          Advanced options
        </AdvancedLink>

        <br /><br /><br />

        <ButtonWrap>
          <ButtonApp variant="contained">
            Save
          </ButtonApp>
        </ButtonWrap>

      </Main>
    );
  }
}

export default Warehouses;



// WEBPACK FOOTER //
// ./src/components/IterioApp/Warehouses/Warehouses.jsx